import Vue from "vue";
import Vuex from "vuex";
import mappingOverview from "@/store/modules/mappingOverview";
import attributeOverview from "@/store/modules/attributeOverview";
import quickMappingOverview from "@/store/modules/quickMappingOverview";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    attributeOverview,
    mappingOverview,
    quickMappingOverview
  }
});

export default store;
